import React, { useContext } from "react";
import classnames from "classnames";
import {
  MobileContext,
  LayoutContext,
  ServerNotificationsContext,
  ThemeContext,
} from "components/common";
import NavbarDesktop from "components/Navbar/NavbarDesktop";
import NavbarMobile from "components/Navbar/NavbarMobile";
import HeaderMobile from "components/Header/HeaderMobile";
import HeaderDesktop from "components/Header/HeaderDesktop";
import Drawer from "components/common/Drawer";
import PersistentModal from "components/common/Modals/PersistentModal";
import PersistentOverlay from "components/common/Overlay/PersistentOverlay";
import { aux, darkBackgroundColor, darkThemeName, lightBackgroundColor } from "theme";
import { useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import VerifyBankInfoBanner from "components/Popups/Banners/VerifyBankInfoBanner";
import { BoostBanner } from "components/Pages/Boost/components";
import { NAVBAR_BACKGROUND } from "../components/Navbar/consts";
import LayoutNoPadding from "./LayoutNoPadding";

const Layout = ({ noPadding, children, banner = true }) => {
  const { theme, setDarkTheme } = useContext(ThemeContext);
  /*
    setDarkTheme here is causing react rendering complain
    Cannot update a component (`ThemeProvider`) while rendering a different component (`Layout`).
    To locate the bad setState() call inside `Layout`, follow the stack trace as described in https://fb.me/setstate-in-render
  */
  setDarkTheme();
  const getTheme = () => {
    return (
      <Helmet>
        <style>
          { `body { background-color: ${  theme === darkThemeName ? darkBackgroundColor : lightBackgroundColor  }; }`}
        </style>
      </Helmet>
    );
  };

  const { navWidth, navHeight } = useContext(LayoutContext);
  const { isMobile } = useContext(MobileContext);
  const { roles } = useSelector((state) => state.user);
  const { getNotifications } = useContext(ServerNotificationsContext);

  if (noPadding) {
    return (
      <div>
        {getTheme()}
        <LayoutNoPadding>{children}</LayoutNoPadding>
      </div>
    );
  }

  const criticalNotifications = getNotifications({
    priority: 1,
    resolved: false,
  });
  const hasCriticalNotifications = !!criticalNotifications.length;

  const renderBanners = () => {
    if (roles.credit_card && banner) {
      return (
        <div className="divide-y divide-solid divide-white sm:divide-y-0">
          <VerifyBankInfoBanner />
        </div>
      );
    }
    return null;
  };

  const renderBoostBanner = () => {
    if (roles.user_with_credit_boost_enrolled) {
      return <BoostBanner />;
    }
    return null;
  };

  const renderDesktop = () => (
    <>

      <div
        className="fixed h-full z-10 overflow-y-scroll hide-y-scrollbar"
        style={{ width: navWidth, zIndex: 30, background: NAVBAR_BACKGROUND }}
      >
        <NavbarDesktop />
      </div>
      <div
        className="flex flex-col flex-1 w-full"
        style={{ marginLeft: navWidth }}
      >
        <div
          className="fixed hadow-header z-50"
          style={{
            height: navHeight,
            marginLeft: `-${navWidth}`,
            width: `calc(100% - ${navWidth}px)`,
          }}
        >
          <HeaderDesktop />
        </div>
        <div
          className={classnames(
            "mt-16 w-full lg:mx-auto relative",
          )}
        >
          {renderBoostBanner()}
          {renderBanners()}
          <div className="page w-full">
            {children}
          </div>
        </div>
      </div>
    </>
  );

  const renderMobile = () => (
    <>
      <div className="fixed z-50 w-full" style={{ height: navHeight }}>
        <HeaderMobile />
      </div>
      <div
        className="flex-1 w-full"
        style={{
          marginBottom: hasCriticalNotifications
            ? aux.mobile.criticalBannerHeight
            : 0,
        }}
      >
        <div
          className={classnames("mt-16 w-full lg:mx-auto relative")}
        >
          {renderBoostBanner()}
          <div className="page w-full">
            {children}
          </div>
        </div>
      </div>
      <div
        className="fixed w-full"
        style={{
          bottom: aux.mobile.navbarHeight,
          zIndex: 60,
        }}
      >
        {renderBanners()}

      </div>
      <NavbarMobile />
    </>
  );

  return (
    <div className="flex bg-neutral-50 min-h-screen">
      {getTheme()}
      {isMobile ? renderMobile() : renderDesktop()}
      <Drawer />
      <PersistentModal />
      <PersistentOverlay />
    </div>
  );
};

export default Layout;
